export const WORKFLOW_EVENT = "WorkflowEvent";
export const COMMENT = "Comment";
export const WORK_ORDER_EVENT = "WorkOrderEvent";
